import {Map, List} from 'immutable';

import {
  CALL_LIST_REQUEST,
  CALL_LIST_SUCCESS,
  CALL_LIST_FAILURE,
  CALL_READ_REQUEST,
  CALL_READ_SUCCESS,
  CALL_READ_FAILURE,
  CALL_UPDATE_REQUEST,
  CALL_UPDATE_SUCCESS,
  CALL_UPDATE_FAILURE,
  CALL_DELETE_REQUEST,
  CALL_DELETE_SUCCESS,
  CALL_DELETE_FAILURE,
  CALL_FORM_DESTROY,
  CALL_CSV_DOWNLOAD_REQUEST,
  CALL_CSV_DOWNLOAD_SUCCESS,
  CALL_CSV_DOWNLOAD_FAILURE
} from './actions'
import Logger from '../../../lib/Logger';

export default function calls(
  state=Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {}
  }),
  action
) {
  Logger.log('debug', `[calls.reducers] calls(%j, %j)`, state, action);

  switch(action.type) {

    case CALL_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case CALL_LIST_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        pages: {
          [action.order]: {
            [action.limit]: {
              [action.page]: null
            }
          }
        },
        total: action.total,
        lastUpdated: action.receivedAt
      }).setIn(['pages', action.order, action.limit, action.page], List(action.result));

    case CALL_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case CALL_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case CALL_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case CALL_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case CALL_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null
        }
      });

    case CALL_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null
        },
        lastUpdated: action.receivedAt
      });

    case CALL_UPDATE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: false,
          errors: null
        }
      }).setIn(['form', 'errors'], action.error);

    case CALL_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case CALL_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case CALL_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case CALL_FORM_DESTROY:
      return state.mergeDeep({
        form: null
      }).set('form', action.form);

    case CALL_CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true
      });

    case CALL_CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case CALL_CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    default:
      return state;
  }
}

Logger.log('silly', `calls.reducers loaded.`);
